import * as mt from './mutation-types';

import { Owner as OwnerDTO, OwnerAdmittedCount, OwnerFilter } from '@/api/owner/types';
import { PaginatedResponseContent } from '@/api/types';

import { RootState } from '../types';
import { Owner } from './types';
import { ActionContext } from 'vuex';

export default {
  [mt.CLEAR_OWNER] ({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.CLEAR_OWNER);
  },
  [mt.FETCHING_OWNER_BY_KEY] ({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.FETCHING_OWNER_BY_KEY);
  },
  [mt.FETCH_BY_KEY_SUCCESS]({ commit }: ActionContext<Owner, RootState>, owner: OwnerDTO) {
    commit(mt.FETCH_BY_KEY_SUCCESS, { owner });
  },
  [mt.FETCHING_OWNER_BY_ID] ({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.FETCHING_OWNER_BY_ID);
  },
  [mt.FETCH_BY_ID_SUCCESS]({ commit }: ActionContext<Owner, RootState>, owner: OwnerDTO) {
    commit(mt.FETCH_BY_ID_SUCCESS, { owner });
  },
  [mt.FETCH_FAILURE]({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.FETCH_FAILURE);
  },
  [mt.SUBMITING_OWNER]({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.SUBMITING_OWNER);
  },
  [mt.FETCH_OWNER_SUCCESS]({ commit }: ActionContext<Owner, RootState>, owner: OwnerDTO) {
    commit(mt.FETCH_OWNER_SUCCESS, { owner });
  },
  [mt.CREATE_OWNER_FAILURE]({ commit }: ActionContext<Owner, RootState>, owner: OwnerDTO) {
    commit(mt.CREATE_OWNER_FAILURE, { owner });
  },
  [mt.UPDATE_OWNER_FAILURE]({ commit }: ActionContext<Owner, RootState>, owner: OwnerDTO) {
    commit(mt.UPDATE_OWNER_FAILURE, { owner });
  },
  [mt.FETCHING_OWNERS_BY_FILTER] ({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.FETCHING_OWNERS_BY_FILTER);
  },
  [mt.FETCHING_OWNERS_BY_FILTER_SUCCESS]({ commit }: ActionContext<Owner, RootState>, owners: PaginatedResponseContent<OwnerDTO>) {
    commit(mt.FETCHING_OWNERS_BY_FILTER_SUCCESS, { owners });
  },
  [mt.FETCH_OWNERS_FAILURE]({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.FETCH_OWNERS_FAILURE);
  },
  [mt.FETCHING_ADMITTED_COUNT] ({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.FETCHING_ADMITTED_COUNT);
  },
  [mt.FETCH_ADMITTED_COUNT_SUCCESS]({ commit }: ActionContext<Owner, RootState>, admittedCount: OwnerAdmittedCount) {
    commit(mt.FETCH_ADMITTED_COUNT_SUCCESS, { admittedCount });
  },
  [mt.FETCH_ADMITTED_COUNT_FAILED]({ commit }: ActionContext<Owner, RootState>) {
    commit(mt.FETCH_ADMITTED_COUNT_FAILED);
  },
  async [mt.CHANGE_FILTER_VALUE]({ commit, dispatch }: ActionContext<Owner, RootState>, filter: OwnerFilter) {
    commit(mt.CHANGE_FILTER_VALUE, filter);
    await dispatch(mt.PERSIST_FILTER);
  },
  [mt.PERSIST_FILTER] ( { commit }: ActionContext<Owner, RootState>) {
    commit(mt.PERSIST_FILTER);
  },
  [mt.CLEAR_FILTER] ( { commit }: ActionContext<Owner, RootState>) {
    commit(mt.CLEAR_FILTER);
  },
};
